import { EditorView, keymap} from "@codemirror/view"
import { basicSetup } from "codemirror";
import { EditorState } from "@codemirror/state";
import { indentUnit } from "@codemirror/language";
import { python } from "@codemirror/lang-python"
import { sql } from "@codemirror/lang-sql"
import { vscodeKeymap } from "@replit/codemirror-vscode-keymap";


let self;

export default class CodeMirror {
    constructor(nodeElmt, language = "python") {
        
        if (self != null) { return self }
        self = this
        self.node = nodeElmt
        // Choix du langage 
        switch (language) {
            case 'python':
                self.language = python()
                break;
            case 'sql':
                self.language = sql()
                break;
            case 'bash':
                self.language = bash()
                break;
            default:
                self.language = python()

        }

        self.hauteur = "calc(100vh - 125px)"
        self.baseTheme = EditorView.theme({
            "&": {
                fontSize: "12pt",
                border: "1px solid #c0c0c0"
            },
            ".cm-content": {
                fontFamily: "Menlo, Monaco, Lucida Console, monospace",
                minHeight: self.hauteur,
                maxHeight: self.hauteur
            },
            ".cm-gutters": {
                minHeight: "200px"
            },
            ".cm-scroller": {
                overflow: "auto",
                maxHeight: self.hauteur
            }
        });

        self.darkTheme = EditorView.theme({
            "&": {
                fontSize: "12pt",
                border: "1px solid #c0c0c0"
            },
            ".cm-content": {
                fontFamily: "Menlo, Monaco, Lucida Console, monospace",
                minHeight: self.hauteur,
                maxHeight: self.hauteur
            },
            ".cm-gutters": {
                minHeight: "200px"
            },
            ".cm-scroller": {
                overflow: "auto",
                maxHeight: self.hauteur
            }
        });

        self.updateListenerExtension = EditorView.updateListener.of((update) => {
            if (update.docChanged) {
                try{
                    window.element.cloud.outdated()
                }
                catch{
            console.error("Impossible de notifier le changement")
                }
            }
          });

        self.extensions = [
            basicSetup,
            EditorView.lineWrapping,
            indentUnit.of("    "),
            keymap.of([
                ...vscodeKeymap,
            ]),
            self.updateListenerExtension,
            self.baseTheme,
            self.language]


 
        self.view = new EditorView({
            doc : "",
            lineWrapping: true,
            extensions: self.extensions,
            parent: self.node
        })

    }

    setContent(text) {
        self.view.setState(EditorState.create({
            doc: text,
            extensions: self.extensions
        }
        ))
    }
 
} 
